import React, { FC } from 'react';
import { Field } from 'formik';
import { TextArea } from '@getgo/chameleon-web/react';
import { IFormControl } from '../formInterface';
import { useTranslation } from 'react-i18next';

const FormTextArea: FC<IFormControl> = (props) => {
  const { t } = useTranslation();
  const { title, name, required, size, helperText, maxLength, ...rest } = props;

  const characterLimit = Number(maxLength);

  return (
    <Field name={name}>
      {/* highlight label when error occurs  */}
      {({ form, field, meta: { touched, error } }: any) => {
        return (
          <TextArea
            className="full-width"
            isMultiline
            label={required ? title + '*' : title}
            fieldsize={size}
            id={name}
            maxLength={maxLength}
            error={touched && error}
            helperText={
              form.errors[name] && form.touched[name]
                ? t(`event.form.customQuestionError`)
                : helperText !== undefined
                ? helperText
                : String(characterLimit - field.value.length)
            }
            {...rest}
            {...field}
            onChange={(e) => form.handleChange(e)}
          >
            {required ? title + '*' : title}
          </TextArea>
        );
      }}
    </Field>
  );
};

export default FormTextArea;
